import { Order } from '../../Models';
import { healthProviderTitle } from '../../utils/utils';

type NotificationData = {
    title: string;
    body: string;
    playSound: boolean;
} | null;

export function getNotificationConfig(order: Order): NotificationData {
    const { state, hp_authentication: hpAuth } = order;
    const body = healthProviderTitle(order);
    let title = '';
    let playSound = false;

    switch (state) {
        case 'emitted':
            title = '🔵 Nuevo pedido';
            playSound = true;
            break;
        case 'assigned':
            playSound = true;
            if (hpAuth?.state === 'sent') {
                title = '🔒 Token recibido';
            } else if (!hpAuth) {
                title = '⚡️ Pedido asignado';
            }
            break;
        case 'approved':
            title = '✅ Pedido pagado';
            playSound = true;
            break;
        case 'fulfilled':
            title = '🎊 Pedido entregado 🎉';
            break;
        case 'cancellation_requested':
            title = '✴️ Pedido cancelado';
            break;
        default:
            return null;
    }

    return title ? { title, body, playSound } : null;
}
